export enum DataFilterActions {
  SET_DATA_FILTER = 'SET_DATA_FILTER',
  UPDATE_CHART_LIST = 'UPDATE_CHART_LIST',
  SET_SELECTED_AREA_BY_BASIN_ID = 'SET_SELECTED_AREA_BY_BASIN_ID',
  SET_SELECTED_AREA_BY_AREA_NAME = 'SET_SELECTED_AREA_BY_AREA_NAME',
}
